import { defaultPanelList } from '@/views/serviceMonitor/iriskMonitor/settings'
import Storage from '@/utils/storage'
import { deepClone } from '@/utils'
import Vue from 'vue'

// const settingStore = Storage.getItem('settingsMonitor') || null

const getDefaultState = () => {
  return {
    init: true,
    settingParams: {
      changeGrouping: {},
      currency: 'USD',
      includeMarkups: true,
      panelConfig: deepClone(defaultPanelList),
      isSound: false,
      count: 10,
      settingsBrokerList: [],
      settingsDisplayedPanels: deepClone(defaultPanelList),
      bookConfigMode: 1
    },
    rightPanelOpened: Storage.getItem('rightPanelOpened'),
    bottomPanelOpened: Storage.getItem('bottomPanelOpened'),
    detailParams: {
      title: null,
      type: null,
      value: null,
      show: false,
      params: []
    }
  }
}

const state = getDefaultState()

const mutations = {
  SET_PANEL_OPTIONS: (state, panel) => {
    let idx = state.settingParams.panelConfig.findIndex(item => item.id === panel.id)
    if (idx !== -1) {
      state.settingParams.panelConfig.splice(idx, 1, panel)
    }
    else {
      state.settingParams.panelConfig.push(panel)
    }
    Storage.setItem('settingsMonitor', state.settingParams)
  },
  TOGGLE_RIGHTPANEL: state => {
    state.rightPanelOpened = !state.rightPanelOpened
  },
  TOGGLE_BOTTOMPANEL: (state, val) => {
    state.bottomPanelOpened = val
  },
  SET_INIT: (state) => {
    state.init = true
  },
  SET_DETAIL_PARAMS: (state, {title, type, value, show, params}) => {
    state.detailParams.title = title
    state.detailParams.type = type
    state.detailParams.value = value
    state.detailParams.show = show
    state.detailParams.params = params
  },
  CHANGE_SETTING: (state, { key, value }) => {
    if (typeof value === 'object' && !Array.isArray(value)) {
      Vue.set(state.settingParams, key, Object.assign({}, value))
    }
    else {
      Vue.set(state.settingParams, key, value)
    }
    Storage.setItem('settingsMonitor', state.settingParams)
  },
  RESET_STORE: () => {
    // Object.assign(state, getDefaultState())
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  changeOptionSetting({ commit }, data) {
    commit('SET_PANEL_OPTIONS', data)
  },
  initSettings({commit}) {
    commit('SET_INIT')
  },
  changeDetailParams({ commit }, data) {
    commit('SET_DETAIL_PARAMS', data)
  },
  toggleRightPanel({commit }) {
    commit('TOGGLE_RIGHTPANEL')
  },
  toggleBottomPanel({commit}, val) {
    commit('TOGGLE_BOTTOMPANEL', val)
  },
  getDefaultSettings({ state }) {
    let settingParams = Storage.getItem('settingsMonitor')
    state.settingParams.changeGrouping = settingParams.changeGrouping || {}
    state.settingParams.currency = settingParams.currency || 'USD'
    // state.settingParams.includeMarkups = settingParams.includeMarkups || true
    state.settingParams.includeMarkups = settingParams.includeMarkups===null || settingParams.includeMarkups===undefined ? true : Boolean(settingParams.includeMarkups)
    state.settingParams.panelConfig = settingParams.panelConfig || deepClone(defaultPanelList)
    state.settingParams.isSound = settingParams.isSound || false
    state.settingParams.count = settingParams.count || 10
    state.settingParams.settingsBrokerList = settingParams.settingsBrokerList || []
    state.settingParams.settingsDisplayedPanels = settingParams.settingsDisplayedPanels || deepClone(defaultPanelList)
    state.settingParams.bookConfigMode = settingParams.bookConfigMode || 1
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
